import * as types from './types';

const initialState = {
  dashboard: {}
};

export default function clientsReducer(state = initialState, action) {
  switch (action.type) {
    case types.UPLOAD_METADATA_SUCESS: {
      return {
        ...state,
        uploadDataSummary: action.payload
      };
    }
    case types.UPLOAD_METADATA_FAILURE:
      return { ...state, error: action.payload };

    default:
      return state;
  }
}
